<script>
export default {
    props: {
        error: {
            type: String,
            required: true
        }
    }
}
</script>

<template>
    <div class="flex h-full items-center justify-center">
        <div class="flex flex-col items-center justify-center space-y-0.5">
            <span class="lnr icon-cross-circle !text-4xl !text-red-500 mb-2 inline-block w-8 text-center"></span>
            <span class="text-base font-medium">Error</span>
            <span class="text-sm text-gray-500">{{ error }}</span>
        </div>
    </div>
</template>